/**
 * Shared Confirm Modal Component
 */

import React from 'react';
import { Modal, Button, Flex, Stack, useTheme, spacing } from '@fti/design-system';

interface ConfirmModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: 'danger' | 'warning' | 'default';
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmModal({
  isOpen,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  variant = 'default',
  onConfirm,
  onCancel,
}: ConfirmModalProps) {
  const { theme } = useTheme();

  if (!isOpen) return null;

  const confirmColor = variant === 'danger' ? 'error' : variant === 'warning' ? 'warning' : 'primary';

  return (
    <Modal isOpen={isOpen} onClose={onCancel}>
      <Modal.Header>
        <h3 style={{ margin: 0, fontSize: '1.1rem', color: theme.colors.text.primary }}>{title}</h3>
      </Modal.Header>
      <Modal.Body>
        <p style={{ margin: 0, color: theme.colors.text.secondary, fontSize: '0.9rem' }}>
          {message}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Flex gap="sm" justify="end">
          <Button variant="ghost" size="sm" onClick={onCancel}>
            {cancelLabel}
          </Button>
          <Button variant="solid" color={confirmColor} size="sm" onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </Flex>
      </Modal.Footer>
    </Modal>
  );
}
